import React from 'react';
import { Grid } from '@mui/material';
import {
  RoleBox,
  ContactGridContainer,
} from './Contact.styles';
import { TextField } from '../../atoms/TextField';
import { SelectMenu } from '../../atoms/SelectMenu';
import { ContactProps } from './Contact.props';
import { EmailTextField } from '../../molecules/EmailTextField';
import { GRID_SPACING } from '../../../configs/ui-constants';

export const Contact: React.FC<ContactProps> = ({
  contactType,
  onChange,
  error,
  contactData,
  renderNotes = true,
  disableTypeSelection = false,
  hideContactType,
  hasContactEditPermission = true
}) => {
  return (
    <RoleBox>
      <ContactGridContainer container spacing={GRID_SPACING}>
        {!hideContactType &&
          <Grid size={{ xs: 4 }}>
            <SelectMenu
              id="page-size-menu"
              minWidth="100%"
              items={contactType || []}
              selectedValue={contactData.contactType}
              disabled={disableTypeSelection}
              onChange={(text) => {
                onChange({
                  ...contactData,
                  contactType: text
                });
              }}
            />
          </Grid>
        }
        <Grid size={{ xs: 4 }}>
          <TextField
            fullWidth
            disabled={!hasContactEditPermission}
            error={error}
            label="Name"
            value={contactData.contactName}
            onChange={(text) => onChange({
              ...contactData,
              contactName: text
            })}
          />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <TextField
            fullWidth
            disabled={!hasContactEditPermission}
            error={error}
            label="Organisation"
            value={contactData?.organization}
            onChange={(text) => onChange({
              ...contactData,
              organization: text
            })}
          />
        </Grid>
      </ContactGridContainer>
      <ContactGridContainer container spacing={GRID_SPACING}>
        <Grid size={{ xs: 4 }}>
          <TextField
            fullWidth
            disabled={!hasContactEditPermission}
            error={error}
            label="Phone 1"
            value={contactData?.phone1}
            onChange={(text) => onChange({
              ...contactData,
              phone1: text
            })}
          />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <TextField
            fullWidth
            disabled={!hasContactEditPermission}
            error={error}
            label="Phone 2"
            value={contactData?.phone2}
            onChange={(text) => onChange({
              ...contactData,
              phone2: text
            })}
          />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <EmailTextField
            fullWidth
            disabled={!hasContactEditPermission}
            value={contactData?.email}
            onChange={(text) => onChange({
              ...contactData,
              email: text
            })}
          />
        </Grid>
      </ContactGridContainer>
      {renderNotes && <Grid container spacing={GRID_SPACING}>
        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            disabled={!hasContactEditPermission}
            label="Notes"
            multiline
            rows={4}
            value={contactData?.notes}
            onChange={(text) => onChange({
              ...contactData,
              notes: text
            })}
          />
        </Grid>
      </Grid>}
    </RoleBox>
  );
};
